import React from 'react';
import BaseComponent from "../../base/BaseComponent";
import {Row, Col} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import {NAVIGATE_CLOSE} from "../../constants";


class IndexLayout extends BaseComponent {

    contents = [];

    sysConfigLoadOver() {
        if(this.sysConfig.length > 0){
            this.sysConfig.map((config)=>{
                let content = require(`./content/${config.content}`).default;
                this.contents.push(content);
            });
        }
    }

    render() {
        let height = window.innerHeight - parseInt(NAVIGATE_CLOSE);
        return (
            <Scrollbars
                // autoHide
                autoHeight
                autoHeightMax={height}
            >
                <Row align={"top"}>
                    {
                        this.contents.length > 0 && this.sysConfig.map((config, index) =>{
                            let ComponentName = this.contents[index];
                            return <Col span={config.span} className={'col-box'} style={{height:config.height}}><ComponentName height={config.height - 10} sysConfigKeyParamsVal={config.key}/></Col>
                        })
                    }
                </Row>
                <style>
                    {`.col-box{padding:5px;}`}
                </style>
            </Scrollbars>
        );
    }
}

export default IndexLayout;